// extracted by mini-css-extract-plugin
export var mainHolder = "Layout-module--mainHolder--3Jj1h";
export var bgImageHolder = "Layout-module--bgImageHolder--qsGv3";
export var headerHolder = "Layout-module--headerHolder--2ane_";
export var smallLogoHolder = "Layout-module--smallLogoHolder--P3hIR";
export var logoHolder = "Layout-module--logoHolder--3X89I";